<template>
  <div id="app">
    <!-- 全局加载覆盖层 -->
    <LoadingOverlay />
    
    <!-- 登录页面不需要布局 -->
    <template v-if="route.path === '/login'">
      <router-view />
    </template>
    <!-- 其他页面使用布局 -->
    <template v-else>
      <BaseLayout>
        <router-view />
      </BaseLayout>
    </template>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import BaseLayout from "./components/BaseLayout.vue";
import LoadingOverlay from "./components/LoadingOverlay.vue";

const route = useRoute();
</script>

<style>
:root {
  --primary-color: #FE304C;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  background-color: #f5f5f5;
}

#app {
  width: 100%;
  min-height: 100vh;
}
</style>
